import * as yup from 'yup';

import type { Locales } from '@/services/types/api.types';
import { localizableString } from '@/helpers/validation.helper';

export interface CtaButtonsValidationOptions {
  includeSecondaryButton?: boolean;
}

const isUrlLink = (enabled: boolean, linkType?: 'url' | 'module' | null) => enabled && linkType === 'url';
const isModuleLink = (enabled: boolean, linkType?: 'url' | 'module' | null) => enabled && linkType === 'module';

export const createCtaButtonValidationSchema = (languageEnabled: Locales[] = []) => {
  return yup.object().shape({
    enabled: yup.boolean().required(),
    linkType: yup.mixed<'url' | 'module'>().when('enabled', {
      is: true,
      then: () => yup.mixed<'url' | 'module'>().oneOf(['url', 'module']).required(),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
    text: yup.mixed().when('enabled', {
      is: true,
      then: () => localizableString(languageEnabled),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
    url: yup.mixed().when(['enabled', 'linkType'], {
      is: isUrlLink,
      then: () => localizableString(languageEnabled),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
    moduleId: yup.mixed().when(['enabled', 'linkType'], {
      is: isModuleLink,
      then: () => yup.number().required(),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
  });
};

export const createCtaButtonsValidationSchema = (
  languageEnabled: Locales[] = [],
  options: CtaButtonsValidationOptions = {},
) => {
  const { includeSecondaryButton = true } = options;
  const buttonSchema = createCtaButtonValidationSchema(languageEnabled).required();
  const fields: Record<string, yup.AnySchema> = {
    button1: buttonSchema,
  };

  if (includeSecondaryButton) {
    fields.button2 = buttonSchema;
  }

  return yup.object().shape(fields);
};
